import { updateObject } from "../../shared/utilities/reducer";
import common from "../../shared/utilities/util";
import {ASYNC_FETCH,ASYNC_FETCH_SUCCESS_PENDINGORDER,ASYNC_FETCH_FAILURE,ASYNC_FETCH_CANCEL_PENDINGORDER_TRIGGERED} from "../constants";

const initialState = {
    isFetching: true,
    statusCode: "",
    statusMessage: "",
    errorMessage: '',
    errorDesc: '',
    actionName: '',
    actionValue: '',
    errorObj: {},
    pageData: "",
    selectedDestList:{},
    pendingOrderApiTriggeredVal:false
};

export const asyncFetch = (state, action) => {
    console.log("getSectionsBegin called")
    return updateObject(state, {
        isFetching: true
    });
};

export const asyncFetchSuccess = (state, action) => {
    return updateObject(state, {
        isFetching: false,
        statusCode: action.msResp.responseInfo && action.msResp.responseInfo.responseCode,
        statusMessage: action.msResp.responseInfo && action.msResp.responseInfo.responseMessage,
        errorMessage: common.isError(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
        errorDesc: common.isErrorDesc(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
        actionName: common.isActionName(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
        actionValue: common.isActionValue(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
        errorObj: action.msResp.responseInfo && action.msResp.responseInfo.responseCode !== "00" && action.msResp.responseInfo ? action.msResp.responseInfo && action.msResp.responseInfo.sectionErrors : null,
        pageData: action.msResp.body.data
    });
};

export const asyncFetchFailed = (state, action) => {
   
    
    let msResp = action && action.err && action.err.response && action.err.response.data;
    let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
    let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
    let body = msResp && msResp.body;
    return updateObject(state, {
        isFetching: false,
        pageData: {},
        statusCode: responseCode ? responseCode : '',
        errorMessage: common.isError(responseCode, responseMessage, body),
        errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
        actionName: common.isActionName(responseCode, responseMessage, body),
        actionValue: common.isActionValue(responseCode, responseMessage, body),
        errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
    });
};



export const setPendingOrderApiTriggeredVal = (state, action) => {
  
    return updateObject(state, {
        pendingOrderApiTriggeredVal: action.data
    });
  };


export const PendingOrderReducer = (state = initialState, action) => {

    const { type } = action;
    switch (type) {
        case ASYNC_FETCH:
            return asyncFetch(state, action);
        case ASYNC_FETCH_SUCCESS_PENDINGORDER:
            return asyncFetchSuccess(state, action);
        case ASYNC_FETCH_FAILURE:
            return asyncFetchFailed(state, action);
        case ASYNC_FETCH_CANCEL_PENDINGORDER_TRIGGERED:
       return setPendingOrderApiTriggeredVal(state, action);
        default:
            return state;
    }
};
